import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchMattersList } from "../actions/matterActions";

import MattersList from "./MattersList";

class AllMattersList extends Component {
	constructor(props, context) {
		super(props, context);
	}
	componentDidMount() {
		this.props.fetchMattersList({
			filter: {},
		});
	}

	render() {
		return <MattersList showMatterFilterTabs />;
	}
}
const mapStateToProps = () => ({});
export default connect(mapStateToProps, { fetchMattersList })(AllMattersList);
